import styled from 'styled-components';
import { TypographyStyles, colours, media, spacing } from '../../../stylings';
import { anchorTagHoverAnimation } from '../../../stylings/anchorTag';

export const FooterAccordionWrapper = styled.div`
  @media ${media.greaterThan('lg')} {
    padding: ${spacing.M} 0;
  }
`;
export const FooterAccordionHeaderText = styled.h3`
  ${TypographyStyles.Body.Medium.SemiBold}
`;
export const FooterAccordionLinks = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS};
  padding: 0;
`;
export const FooterAccordionCommonLinkItem = styled.li`
  ${TypographyStyles.Body.Tiny.Regular}

  ${() =>
    anchorTagHoverAnimation({
      backgroundColor: colours.BLACK,
    })}

    a {
    color: ${colours.BLACK};
    padding: 5px 0;
    text-decoration: none;
  }
`;
export const AccordionLinkLabelIcon = styled.span`
  padding-right: ${spacing.XS};
`;
export const DesktopContainer = styled.div`
  display: none;

  @media ${media.greaterThan('lg')} {
    display: unset;
  }
`;
export const MobileContainer = styled.div`
  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;
